import { render, staticRenderFns } from "./paramsAccess.vue?vue&type=template&id=09e650ca&scoped=true"
import script from "./paramsAccess.vue?vue&type=script&lang=js"
export * from "./paramsAccess.vue?vue&type=script&lang=js"
import style0 from "./paramsAccess.vue?vue&type=style&index=0&id=09e650ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e650ca",
  null
  
)

export default component.exports